<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="6" lg="4">
        <v-text-field
            v-model="details.payU_orderId"
            hint="Id zamówienia PayU. Zawsze puste jeśli kwota jest równa 0."
            persistent-hint
            disabled
        />
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <v-text-field
            v-model="details.amount"
            hint="Kwota w groszach"
            persistent-hint
            disabled
        >
          <template slot="append-outer">
            <span style="white-space: nowrap">
              {{ formatAmount(details.amount || 0) }} PLN
            </span>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="6" lg="5">
        <v-text-field
            v-model="details.status"
            hint="Status (https://developers.payu.com/pl/restapi.html#notifications)"
            persistent-hint
            disabled
        />
      </v-col>
      <v-col cols="12" md="3" lg="6">
        <v-text-field
            v-model="details.statusChangedBy"
            hint="Status ustawiony przez"
            persistent-hint
            disabled
        >
          <template
              v-if="details.statusChangedByUserId"
              v-slot:append-outer
          >
            <router-link
                :to="{name: 'user-details', params: {id: details.statusChangedByUserId}}"
            >
              #{{ details.statusChangedByUserId }}
            </router-link>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="3" lg="6">
        <v-text-field
            v-model="statusChangedAtFormatted"
            hint="Data zmiany statusu"
            persistent-hint
            disabled
        />
      </v-col>
      <v-col cols="12">
        <v-textarea
            v-model="details.statusChangeReason"
            rows="2"
            hint="Powód ustawienia statusu."
            persistent-hint
            readonly
        />
      </v-col>
      <v-col cols="12">
        <v-textarea
            v-model="details.description"
            hint="Opis"
            persistent-hint
            rows="2"
            disabled
        />
      </v-col>
    </v-row>
    <v-row v-if="details.buyerId">
      <v-col cols="12" class="text-center">
        <v-btn
            class="mx-3"
            @click="goToUserDetails(details.buyerId)"
        >
          Przejdź do użytkownika
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center pb-0">
        <h3>
          Dane kupującego
        </h3>
        <small>
          (Zapisywane tylko w przypadku płatności kartą)
        </small>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-text-field
            v-model="details.buyer.firstName"
            hint="Imię"
            persistent-hint
            disabled
            counter="100"
        />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-text-field
            v-model="details.buyer.lastName"
            hint="Nazwisko"
            persistent-hint
            disabled
            counter="100"
        />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-text-field
            v-model="details.buyer.email"
            hint="Email"
            persistent-hint
            disabled
            counter="254"
        />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-text-field
            v-model="details.buyer.phone"
            hint="Telefon"
            persistent-hint
            disabled
            counter="30"
        />
      </v-col>
    </v-row>
    <modal-loader :show="loading"/>
  </v-container>
</template>

<script>
import api from "@/services/api";
import ModalLoader from "@/components/ModalLoader";
import formatters from "@/mixins/formatters";

export default {
  props: {
    id: {
      type: [String],
      required: false,
      default: null,
    },
  },
  mixins: [
    formatters,
  ],
  components: {
    ModalLoader,
  },
  data() {
    return {
      default: {

      },
      details: {
        id: null,
        buyerId: null,
        payU_orderId: null,
        buyer: {
          firstName: null,
          lastName: null,
          email: null,
          phone: null,
        },
        quantity: null,
        amount: null,
        status: null,
        description: null,
      },
      label: {

      },
      rules: {

      },
      loading: false,
      saving: false,
    };
  },
  computed: {
    statusChangedAtFormatted() {
      const ts = this.details.statusChangedAt ? this.details.statusChangedAt.timestamp : null

      if (!ts) {
        return ''
      }

      return this.localDateTime(ts)
    },
  },
  created() {
    if (this.id) {
      this.get();
    }
  },
  methods: {
    isIdle() {
      return !this.loading && !this.saving;
    },
    get() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      api.get(`/api/transaction/${this.id}`)
          .then((response) => {
            this.details = response.data;
          })
          .catch((error) => {
            this.$root.$emit('notifyError', {
              html: 'Nie udało się pobrać danych płatności.',
              error,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    goToUserDetails(id) {
      this.$router.push({name: 'user-details', params: {id: id}})
          .catch((error) => {
            console.error('Error during redirection:', error);
          });
    },
  },
}
</script>